export default __webpack_public_path__ + "static/media/railway museum.17ea7b32.jpg";